<template>
  <div class="bottom_area">
    <div v-if="buttonsSettings.length" class="pa-4 bottom_area__top_section">
      <v-row
        v-for="(buttonRow, rowIndex) in buttonsSettings"
        :key="`bottom-navigation-button-row_${rowIndex}`"
      >
        <v-col
          v-for="(button, index) in buttonRow"
          :key="`bottom-navigation-button_${index}`"
          :cols="Math.round(12 / buttonRow.length)"
        >
          <SendButton
            v-if="button.loading !== undefined"
            block
            :loading="button.loading"
            :button-text="button.text"
            :disabled="button.disabled"
            :color="button.color"
            :class="button.domClass"
            @click="button.action()"
          />
          <v-btn
            v-else
            block
            :color="button.color"
            :disabled="button.disabled"
            :class="button.domClass"
            @click="button.action()"
          >
            {{ button.text }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-show="showBottomNavigation" class="bottom_area__bottom_navigation white">
      <v-row no-gutters align="center">
        <v-col
          v-for="(item, index) in links"
          :key="index"
          cols="auto"
          class="text-center flex-grow-1"
          :class="{
            'primary--text': isCurrent(item)
          }"
          @click="$router.push($localePath(item.location))"
        >
          <div class="py-2">
            <v-icon
              size="34"
              class="d-block mx-auto bottom_area__bottom_navigation__item"
              :class="{
                'primary--text': isCurrent(item)
              }"
            >
              {{ `${item.mobileIcon}${isCurrent(item) ? 'Selected' : ''}` }}
            </v-icon>
            <div
              :class="` ${isHu ? 'navigation-small-text' : 'text-h5'} ${
                currentPath.includes(item.location) ? 'primary' : 'grey-darken-1'
              }--text`"
            >
              {{ item.title }}
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import profileNavigation from '@/mixins/profileNavigation';
import { mapGetters } from 'vuex';
export default {
  name: 'BottomNavigation',
  mixins: [profileNavigation],
  watch: {
    showBottomNavigation() {
      this.calculateBottomOffset();
    },
    buttonsSettings() {
      this.calculateBottomOffset();
    }
  },
  computed: {
    ...mapGetters({
      buttonsSettings: 'profile/bottomNavigation/buttonsSettings',
      showBottomNavigation: 'profile/bottomNavigation/showBottomNavigation'
    })
  },
  mounted() {
    this.calculateBottomOffset();
  },
  methods: {
    isCurrent(item) {
      return this.currentPath.includes(item.location);
    },
    calculateBottomOffset() {
      this.$nextTick(() => {
        let navigationHeight = this.$el.getBoundingClientRect().height + 24;

        const elementsToMargin = document.querySelectorAll('.bottom-navigation-offset');
        elementsToMargin.forEach(el => {
          el.style.marginBottom = `${navigationHeight}px`;
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.navigation-small-text {
  font-size: 9px;
  font-weight: 700;
  font-family: 'PangramSans', sans-serif !important;
  line-height: 14px;
  letter-spacing: 0.36px !important;
}
.bottom_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  display: none;

  @media #{map-get($display-breakpoints, 'md-and-down')}, #{map-get($display-breakpoints, 'xl-and-down')} and (max-height: 680px) {
    display: block;
  }

  &__top_section {
    border-top: $border-width solid $grey-lighten;
    background-color: rgba($white, 0.8);
    backdrop-filter: blur(10px);
  }

  &__bottom_navigation {
    width: 100%;

    .col {
      border-top: $border-width solid $grey-lighten;
    }

    &__item {
      transition: none !important;
    }
  }
}
</style>
